module.exports = __webpack_public_path__ + "img/knusprigeentemithintergrund.1fa9b4f5.jpg";